// extracted by mini-css-extract-plugin
export var link = "index-module--link--sq7zP";
export var root = "index-module--root--xMu2q";